import { render, staticRenderFns } from "./dragMenu.vue?vue&type=template&id=2bc02abc&scoped=true&"
import script from "./dragMenu.vue?vue&type=script&lang=js&"
export * from "./dragMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc02abc",
  null
  
)

export default component.exports